// extracted by mini-css-extract-plugin
export var actionPlaceholder = "_9p-3";
export var contentContainer = "_9p-0";
export var editorContainer = "_9p-1";
export var quillInputForm = "_9p-2";
export var zoneDivider = "_9p-4";